import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Form, Input, Label } from "../../../styles";
import { useUserContext } from "../../../context/user_context";
import { useDebtContext } from "../../../context/debt_context";
import Api from "../../../api/axios";
import { amountPlaceholder, emailPlaceholder, namePlaceholder, phonePlaceholder } from "../../../utils/data";


const AddCreditor = (props) => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({});

  const {
    showAddCreditor, CloseAddCreditor,
    getDebtData
  } = useDebtContext();

  const { btoken, stoken } = useUserContext();

  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  function clear() {
    setformField({
      name: "",
      phone: '',
      mail: '',
      amount: '',
      duedate: '',
    });
  }

  function submitFn(e) {
    e.preventDefault();
    if (formField.name) {
      setissending(true);
      const data = {
        btoken, stoken,
        name: formField.name,
        phone: formField.phone,
        mail: formField.mail,
        amount: formField.amount,
        duedate: formField.duedate,
      };

      Api.post(`/addCreditor`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            getDebtData();
            CloseAddCreditor();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.error("Name is required !!!");
    }
  }


  return (
    <>
      <Modal
        show={showAddCreditor}
        onHide={CloseAddCreditor}
        backdrop="static"
        keyboard={true}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text">
              Create new Creditor
            </h6>
          </Modal.Header>


          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>
              <div className="row justify-content-center text-start">


                <Label> Name: <span>*</span> </Label>
                <Input
                  type="text"
                  name="name"
                  placeholder={namePlaceholder}
                  onChange={handleChange}
                  required
                  value={formField.name}
                />

                <Label> Email: <span>*</span>  </Label>
                <Input
                  type="email"
                  name="mail"
                  placeholder={emailPlaceholder}
                  onChange={handleChange}
                  required
                  value={formField.mail}
                />

                <Label> Phone Number: <span>*</span>  </Label>
                <Input
                  type="number"
                  name="phone"
                  placeholder={phonePlaceholder}
                  onChange={handleChange}
                  required
                  value={formField.phone}
                />

                <Label> Amount: <span>*</span>  </Label>
                <Input
                  type="number"
                  name="amount"
                  placeholder={amountPlaceholder}
                  onChange={handleChange}
                  required
                  value={formField.amount}
                />

                <Label> Due Date: <span>*</span>  </Label>
                <Input
                  type="date"
                  name="duedate"
                  onChange={handleChange}
                  required
                  value={formField.duedate}
                />

                <div className="col-md-10 mb-4 mx-auto text-center">
                  <Button
                    pry
                    type="submit"
                    disabled={issending}
                    className="btn m-0 w-100"  >
                    {issending ? 'loading...' : "Submit"}
                  </Button>
                </div>
              </div>
            </Form>
          </div>

        </Modal.Body>
      </Modal>

    </>
  );
};

export default AddCreditor;
